import type { Background, Mask } from '../data/v1'
import { BackgroundFill } from './background-fill'
import { MaskFill } from './mask-fill'

export type BackdropLayerRendererProps = {
	layerId: string
	background: Background
	mask: Mask
}

export function BackdropLayerRenderer({ layerId, background, mask }: BackdropLayerRendererProps) {
	return (
		<div data-layer-id={layerId} className="absolute inset-0">
			<BackgroundFill background={background} />
			<MaskFill mask={mask} />
		</div>
	)
}
